import toPath from './toPath'

const toKey = value => {
	if (typeof value === 'string') {
		return value
	}
	const result = `${value}`
	return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result
}

function baseGet(obj, path) {
	path = toPath(path, obj)

	const length = path.length
	let idx = 0

	while (obj != null && idx < length) {
		obj = obj[toKey(path[idx++])]
	}

	return (idx && idx == length) ? obj : undefined
}


export default function getInObject(obj, path, defaults) {
	const result = obj == null ? undefined : baseGet(obj, path)
	return result === undefined ? defaults : result
}
